export default function RealCases() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-6 sm:p-10 md:p-12 text-white">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 md:mb-6">
            Обучение на реальных ситуациях компании
          </h2>
          <p className="text-sm md:text-base text-white/90 max-w-3xl leading-relaxed mb-6">
            Вместо абстрактных упражнений можно использовать ситуации, с которыми руководители сталкиваются непосредственно в своей работе: сложный сотрудник, невыполнение KPI, конфликт, сопротивление изменениям, нарушение договорённостей, необходимость дать неприятную обратную связь.
          </p>
          <p className="text-sm md:text-base text-white/90 max-w-3xl leading-relaxed">
            Содержание программы адаптируется под реальные управленческие ситуации вашей компании — мы не используем шаблонные решения, а работаем с конкретными вызовами, которые стоят перед вашими руководителями.
          </p>
        </div>
      </div>
    </section>
  );
}